import { closePurple } from 'assets/images';
import { CADENA_VACIA } from 'utils/constants';
import { TEST_ID_CERRAR_MODAL_POLIGONO } from './outageDashboard.constants';
import useStyles from './OutageDashboardStyles';

/**
 * Cierre del dashboard en la misma fila que la pastilla (CSS grid / flex).
 * @param onCerrar cierra el modal de tracking
 */
const BotonCerrarDashboard = ({ onCerrar }: { onCerrar: () => void }) => {
  const styles = useStyles();

  return (
    <button
      type="button"
      className={styles.botonCerrarCabecera}
      onClick={onCerrar}
      aria-label="cerrar"
      title="cerrarBotom"
      data-testid={TEST_ID_CERRAR_MODAL_POLIGONO}
    >
      <img src={closePurple} alt={CADENA_VACIA} className={styles.iconoCerrarCabecera} />
    </button>
  );
};

export default BotonCerrarDashboard;
